export default {
  "resourceType": "QuestionnaireResponse",
  "id": "",
  "status": "in-progress",
  "author": {
    "reference": "",
    "display": ""
  },
  "source": {
    "reference": "",
    "display": ""
  },
  "item": [
    {
      "linkId": "A",
      "text": "Background Information",
      "item": [
        {
          "linkId": "1",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "B",
      "text": "Introduction",
      "item": [
        {
          "linkId": "2",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "C",
      "text": "Follow-Up",
      "item": [
        {
          "linkId": "3",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "D",
      "text": "Medication and Supplements",
      "item": [
        {
          "linkId": "4",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "E",
      "text": "Recurrence",
      "item": [
        {
          "linkId": "5",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "F",
      "text": "Genetics",
      "item": [
        {
          "linkId": "6",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "G",
      "text": "Treatment",
      "item": [
        {
          "linkId": "7",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "H",
      "text": "Late Effects: Psychological",
      "item": [
        {
          "linkId": "8",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "I",
      "text": "Late Effects: Head and Neck",
      "item": [
        {
          "linkId": "9",
          "text": "Please review the recommendations for this section:",
        }
      ]
    },
    {
      "linkId": "J",
      "text": "Late Effects: Auditory",
      "item": [
        {
          "linkId": "10",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "K",
      "text": "Late Effects: Dental",
      "item": [
        {
          "linkId": "11",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "L",
      "text": "Late Effects: Endocrine/Metabolic",
      "item": [
        {
          "linkId": "12",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "M",
      "text": "Late Effects: Urinary",
      "item": [
        {
          "linkId": "13",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "N",
      "text": "Late Effects: Reproductive (Female)",
      "item": [
        {
          "linkId": "14",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "O",
      "text": "Late Effects: Reproductive (Male)",
      "item": [
        {
          "linkId": "15",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "P",
      "text": "Late Effects: Cardiovascular",
      "item": [
        {
          "linkId": "16",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "Q",
      "text": "Late Effects: Pulmonary",
      "item": [
        {
          "linkId": "17",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "R",
      "text": "Late Effects: Gastrointestinal / Hepatic",
      "item": [
        {
          "linkId": "18",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "S",
      "text": "Late Effects: Musculoskeletal",
      "item": [
        {
          "linkId": "19",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "T",
      "text": "Late Effects: Central Nervous System",
      "item": [
        {
          "linkId": "20",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "U",
      "text": "Late Effects: Dermatologic",
      "item": [
        {
          "linkId": "21",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "V",
      "text": "Late Effects: Immune",
      "item": [
        {
          "linkId": "22",
          "text": "Please review the recommendations for this section:"
        }
      ]
    },
    {
      "linkId": "W",
      "text": "Late Effects: Pain/Chronic",
      "item": [
        {
          "linkId": "23",
          "text": "Please review the recommendations for this section:"
        }
      ]
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/BlankRecResponse.js